import { styled } from "@mui/material";

export const StoreBadgeImage = styled("img")`
	height: 52px;
	width: auto;
	display: block;

	@media (max-width: 480px) {
		height: 48px;
	}
`;
